export const prefixTranslation = 'monitoring.externalCourse'
